<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card :disabled="loading" :loading="loading">
          <v-toolbar color="secondary" dark>
            <v-toolbar-title>
              <v-icon left>mdi-clipboard-text</v-icon>Catalogs
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="createDialog" max-width="900">
              <template #activator="{on}">
                <v-btn v-on="on">Add Catalog</v-btn>
              </template>
              <v-card>
                <v-card-title>Add catalog</v-card-title>
                <v-card-text>
                  <v-form ref="createCatalog">
                    <v-text-field v-model="newName" label="Name" :rules="mandatoryRules"/>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn @click="createDialog = !createDialog">Cancel</v-btn>
                  <v-spacer />
                  <v-btn @click="doCreate">Add</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :items="catalogs"
              :headers="headers"
            >
              <template #[`item.actions`]="{item}">
                <v-btn icon :to="'/products/catalog/' + item.id">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
      
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data: () => ({
    headers:[
      { text: 'Name', align: 'left', sortable: true, value: 'name'},
      { text: 'Actions', align: 'left', sortable: false, value: 'actions' }
    ],
    newName: '',
    createDialog: false,
    mandatoryRules: [(v) => !!v || "This fields is mandatory"],
  }),
  mounted() {
    this.getCatalogs();
  },
  computed:{
    ...mapGetters('catalogs', ['catalogs', 'loading'])
  },
  methods: {
    ...mapActions('catalogs', ['getCatalogs', 'createCatalog']),
    doCreate(){
      if(this.$refs.createCatalog.validate()){
        this.createCatalog({name: this.newName})
        .then((res) => {
          this.$router.push(`/products/catalog/${res.catalog.id}`)
        })
      }
    }
  },
};
</script>
